<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="policy-editor-container">
    <div class="button-wrapper">
        <div class="policy-name"><span class="mdi mdi-wallet-membership policy-name-icon"></span>{{ d3ePolicyName }}
        </div>
        <div class="button-container">
            <span tabindex="0">
              <button id="cancelBtn" mat-raised-button [disabled]="!isDirty" (click)="onCancel()"
                      aria-label="The Cancel button is disabled until changes are made to the policy.">
                {{ 'CANCEL' | translate }}
              </button>
              <button id="saveBtn" mat-raised-button color="primary" [disabled]="!isDirty" (click)="onSave()"
                      aria-label="The Save button is disabled until changes are made to the policy.">
                {{ 'SAVE' | translate }}
              </button>
            </span>
        </div>
    </div>
    <div id="policy-editor" class="policy-editor-wrapper">
        <div *ngIf="isDirty === false">
            <span class="policy-is-clean"></span>
        </div>

        <div *ngIf="isDirty">
            <span class="policy-is-dirty"></span>
        </div>

        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onSelectedIndexChange($event)"
                       animationDuration="0ms">

            <mat-tab *ngIf="policyPageConfig.bitlockerTab && haveBitLockerTier" label="{{ 'policy.bitlocker.title' | translate }}">
                <ng-template mat-tab-label>
                <span class="tab-icon">
                    <i class="mdi mdi-lock"></i>
                </span>
                    <span class="tab-title">{{ 'policy.bitlocker.title' | translate }}</span>
                </ng-template>
                <span *ngIf="d3ePolicy">
                  <app-bitlocker
                      [attr.inert]="haveBitLockerTier ? null : ''"
                      [d3ePolicy]="d3ePolicy"
                      (onChanged)="onBitlockerChanged()"
                  ></app-bitlocker>
              </span>
            </mat-tab>
            <mat-tab *ngIf="policyPageConfig.pbaTab && havePBATier" label="PBA">
                <ng-template mat-tab-label>
                <span class="tab-icon">
                    <i class="mdi mdi-shield-lock-outline"></i>
                </span>
                    <span class="tab-title">PBA</span>
                </ng-template>
                <span *ngIf="d3ePolicy">
                  <app-pba-info
                      [attr.inert]="havePBATier ? null : ''"
                      [d3ePolicy]="d3ePolicy"
                      (onChanged)="onPbaSettingsChanged()"
                  ></app-pba-info>
                </span>
            </mat-tab>
            @if (policyPageConfig.fdeTab && haveFDETier) {
                <mat-tab label="FDE">
                    <ng-template mat-tab-label>
                    <span class="tab-icon">
                        <i class="mdi mdi-shield-lock-outline"></i>
                    </span>
                        <span class="tab-title">FDE</span>
                    </ng-template>
                    <span *ngIf="d3ePolicy">
                    <app-fde-info
                        [attr.inert]="haveFDETier ? null : ''"
                        [d3ePolicy]="d3ePolicy"
                        (onChanged)="onFdeSettingsChanged()"
                    ></app-fde-info>
                    </span>
                </mat-tab>
            }
            @if (haveDDTier) {
                <mat-tab [disabled]="!policyEnabled" label="{{ 'FILE_TYPES' | translate }}" id="policy-editor-file-types-tab">
                    <ng-template mat-tab-label>
                      <span class="tab-icon">
                          <i class="mdi mdi-file"></i>
                      </span>
                        <span class="tab-title">{{ 'FILE_TYPES' | translate }}</span>
                    </ng-template>
                    <span *ngIf="d3ePolicy">
                      <app-policy-file-types
                              [attr.inert]="haveDDTier ? null : ''"
                              [d3ePolicy]="d3ePolicy"
                              [allowAlwaysOn]="allowAlwaysOn"
                              [clientPolicy]="clientPolicy"
                              [clientPolicyDefaults]="clientPolicyDefaults"
                              [defaultPolicyExtensions]="defaultPolicyExtensions"
                              [importDefaultExts]="importDefaultExts"
                              [policyEnabled]="policyEnabled"
                              [policySections]="policySections"
                              (policyExtensionsChanged)="onDefaultExtensionsChanged($event)"
                              (policyEnableToggleChange)="onPolicyEnableToggleChange($event)"
                              (allowAlwaysOnChanged)="onAllowAlwaysOnChanged($event)"
                              (ransomExtErrorStateChanged)="onRansomExtErrorStateChanged($event)"
                              (ransomExtensionsChanged)="onRansomExtensionsChanged($event)"
                              (extensionErrorStateChanged)="onExtensionErrorStateChanged($event)"
                              (policyCustomExtensionsChanged)="onCustomExtensionsChanged($event)"
                              (import)="onImportDefaultExtensionsChanged($event)"
                      ></app-policy-file-types>
                  </span>
                </mat-tab>
            }

            @if (haveDDTier) {
                <mat-tab [disabled]="!policyEnabled" label="{{ 'FOLDERS' | translate }}" id="policy-editor-folders-tab">
                    <ng-template mat-tab-label>
                  <span class="tab-icon" [ngClass]="{'icon-disabled': !policyEnabled}">
                    <span class="{{getIcon('Folders')}}"></span>
                  </span>
                        <span class="tab-title">{{ 'FOLDERS' | translate }}</span>
                    </ng-template>

                    <app-policy-folders
                            [attr.inert]="haveDDTier ? null : ''"
                            [show_environment_variables]="show_environment_variables"
                            (folderErrorStateChanged)="onFolderErrorStateChanged($event)"
                            (policyFoldersChanged)="onPolicyFoldersChanged($event)"
                            [policyFolders]="policyFolders"
                            [subKeyUUIDs]="subKeyUUIDs"
                            [enableSubscriptionKey]="enableSubscriptionKey">
                    </app-policy-folders>
                </mat-tab>
            }

            <mat-tab [disabled]="!policyEnabled" *ngIf="policyPageConfig.deceptionTab && enableDataDeception && haveDDTier"
                    label="{{ 'DECEPTION' | translate }}">
                <ng-template mat-tab-label>
              <span class="tab-icon" [ngClass]="{'icon-disabled': !policyEnabled}">
                <span class="mdi mdi-hook" aria-hidden="true"></span>
              </span>
                    <span class="tab-title">{{ 'DECEPTION' | translate }}</span>
                </ng-template>

                <app-data-deception-files
                        [attr.inert]="haveDDTier ? null : ''"
                        [show_environment_variables]="show_environment_variables"
                        (deceptionFileErrorStateChanged)="onDeceptionFileErrorStateChanged($event)"
                        (deceptionFilesChanged)="onDeceptionFilesChanged($event)"
                        [deceptionFiles]="deceptionFiles">
                </app-data-deception-files>
            </mat-tab>

            <mat-tab [disabled]="!policyEnabled" *ngIf="policyPageConfig.knownGoodTab && haveDDTier"
                     label="{{ 'SAFE_APPS' | translate }}">
                <ng-template mat-tab-label>
                    <span class="tab-icon" [ngClass]="{'icon-disabled': !policyEnabled}">
                        <span class="mdi mdi-cog"></span>
                    </span>
                    <span class="tab-title">{{ 'SAFE_APPS' | translate }}</span>
                </ng-template>

                <app-policy-known-good
                        [attr.inert]="haveDDTier ? null : ''"
                        [d3ePolicy]="d3ePolicy"
                        (changed)="onKnownGoodAppsChanged()">
                </app-policy-known-good>
            </mat-tab>

            <mat-tab [disabled]="!policyEnabled" label="{{ 'SETTINGS' | translate }}">
                <ng-template mat-tab-label>
                    <span class="tab-icon" [ngClass]="{'icon-disabled': !policyEnabled}">
                        <span class="{{getIcon('Settings')}}"></span>
                    </span>
                    <span class="tab-title">{{ 'SETTINGS' | translate }}</span>
                </ng-template>

                <app-policy-settings
                        [haveDDTier]="haveDDTier"
                        [show_force_policy_checkbox]="show_force_policy_checkbox"
                        [devices]="devices"
                        [d3ePolicy]="d3ePolicy"
                        [forcePolicyRemoval]="overrideLocalPolicy"
                        [clientPolicyDefaults]="clientPolicyDefaults"
                        [allowAlwaysOn]="allowAlwaysOn"
                        (forcePolicyRemovalChanged)="onForcePolicyRemovalChanged($event)"
                        (loadDeviceSettings)="onLoadDeviceSettings($event)"
                        (intervalsChanged)="onIntervalsChanged($event)"
                        (sensorToggleChanged)="onPolicySettingChanged($event)"
                        (allowAlwaysOnChanged)="onAllowAlwaysOnChanged($event)"
                        (forcePreAuthChanged)="onForcePreAuthChanged($event)"
                        (preAuthFileAccessCountChanged)="onPolicySettingChanged($event)"
                        (preAuthFileAccessTimeoutChanged)="onPolicySettingChanged($event)"
                        (ransomwareSensitivityMinChanged)="onPolicySettingChanged($event)"
                        (ransomwareSensitivityMaxChanged)="onPolicySettingChanged($event)"
                        (ransomwareFeatureMaskChanged)="onPolicySettingChanged($event)">
                </app-policy-settings>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
